var React = require('react');

function MeetLouiseImageBackground (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M151.223 12.7225C181.89 8.3727 215.853 -11.5395 241.534 9.43946C267.236 30.4362 265.795 76.3247 273.804 112.862C281.317 147.139 296.752 182.229 286.705 215.52C276.76 248.473 249.137 268.383 222.725 282.114C200.215 293.817 175.436 290.158 151.223 285.957C130.246 282.318 113.049 268.252 93.0689 259.621C61.8445 246.134 11.7871 259.716 1.38068 221.232C-9.00075 182.841 42.1061 160.368 56.3656 123.89C67.6456 95.0342 56.0594 55.1908 74.9348 33.0698C94.2072 10.4837 124.722 16.4815 151.223 12.7225Z","fill":"#9C27B0"}));
}

MeetLouiseImageBackground.defaultProps = {"width":"290","height":"290","viewBox":"0 0 290 290","fill":"none"};

module.exports = MeetLouiseImageBackground;

MeetLouiseImageBackground.default = MeetLouiseImageBackground;
